import { SUPPORTED_LOCALES, type SupportedLocale } from '../i18n'

const CACHE_KEY = 'carbon13_locale'
const CACHE_TTL = 7 * 24 * 60 * 60 * 1000

export function isSupported(lang: string): lang is SupportedLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(lang)
}

export function getCachedLocale(): SupportedLocale | null {
  try {
    const raw = localStorage.getItem(CACHE_KEY)
    if (!raw) return null
    const { locale, ts } = JSON.parse(raw)
    if (Date.now() - ts > CACHE_TTL) return null
    return isSupported(locale) ? locale : null
  } catch {
    return null
  }
}

export function setCachedLocale(locale: SupportedLocale) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({ locale, ts: Date.now() }))
  } catch { /* ignore */ }
}

export function browserLocale(): SupportedLocale {
  const raw = navigator.language?.split('-')[0] || 'en'
  return isSupported(raw) ? raw : 'en'
}
